import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  callSidFunction,
  clickTracker,
  getContractTypeVal,
  getSourceValue,
  trackUserType,
} from '../../../../lib/common';
import { useAuth } from '../../../../contexts/auth';
import style from './Business.module.scss';

function Business({ handleOnLanding, pageType }) {
  const source = getSourceValue();
  const [authState] = useAuth();
  const { selectedBusiness, sidResponse } = authState;
  const queryParams = new URLSearchParams(window.location.search);
  const version = parseFloat(queryParams.get('version') || '0');
  const navigate = useNavigate();

  const handleChatRedirection = async () => {
    const contractType = getContractTypeVal('csportal');
    window.location.href = 'https://wa.me/912240289385?text=Hello';
    const liVal = 'click';
    const liTrd = `click_chat`;
    if (contractType === 'user') {
      await clickTracker('WA_button', 'User_issue');
    } else if (trackUserType?.[contractType]) {
      handleOnLanding(liVal, liTrd, 'click_chat');
      await clickTracker('WA_button', `${trackUserType?.[contractType]}_issue`);
    } else if (!sidResponse) {
      handleOnLanding(liVal, liTrd, 'click_chat');
      await clickTracker('WA_button', 'nonlogin_user');
    }
  };
  const handleCallBackSidCheck = async () => {
    await callSidFunction(source || 2);
  };

  const handleCallBackRedirection = async () => {
    const contractType = getContractTypeVal('csportal');
    const liVal = 'click';
    const liTrd = `click_getcallbck`;
    if (contractType === 'user') {
      await clickTracker('Callback_button', 'User_issue');
    } else if (trackUserType?.[contractType]) {
      if (pageType !== 'faq') {
        handleOnLanding(liVal, liTrd, 'click_getcallbck');
      }
      await clickTracker('Callback_button', `${trackUserType?.[contractType]}_issue`);
    } else if (!sidResponse) {
      if (pageType !== 'faq') {
        handleOnLanding(liVal, liTrd, 'click_getcallbck');
      }
      await clickTracker('Callback_button', 'nonlogin_user');
    }
    if (sidResponse) {
      if (selectedBusiness?.parentid && selectedBusiness?.data_city) {
        if (['paid', 'expiredShort'].includes(contractType)) {
          // navigate('/csportal/create_ticket_new?pageType=home');
          navigate(
            `/csportal/create_ticket?pageType=home&parentId=${selectedBusiness.parentid}&city=${
              selectedBusiness.data_city
            }&key=''&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}
          &raiseTicketTrackerID=landing`,
          );
        } else {
          navigate(
            `/csportal/create_ticket?pageType=home&parentId=${selectedBusiness.parentid}&city=${
              selectedBusiness.data_city
            }&key=''&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}
          &raiseTicketTrackerID=landing`,
          );
        }
      } else {
        navigate('/csportal/userReport?raiseTicketTrackerID=landing');
      }
    } else {
      window.localStorage.clear();
      window.sessionStorage.clear();
      handleCallBackSidCheck();
    }
  };
  return (
    <div
      className={`${style.ButtonGroup}`}
      style={{
        bottom: (source === 53 || source === '53') && version >= 3.3 ? 80 : 0,
      }}
    >
      <button onClick={handleChatRedirection} type="button" className={`${style.Button} blue_whitefill_animate `}>
        <span className={`${style.whatsapp_icon} csicon mr-6`} />
        <span className={`${style.ButtonText} font13 fw600 color007`}>Chat with Us</span>
      </button>
      <button onClick={handleCallBackRedirection} type="button" className={`${style.Button} bluefill_animate `}>
        <span className={`${style.call_icon} csicon mr-6`} />
        <span className={`${style.ButtonText} font13 fw600 colorFFF`}>Get a Callback</span>
      </button>
    </div>
  );
}

Business.propTypes = {
  handleOnLanding: PropTypes.func,
  pageType: PropTypes.string,
};

Business.defaultProps = {
  pageType: '',
};

export default Business;
